<template>
    <ConfidenceLevelCard @save-confidence-settings="handleVal"/>
</template>

<script>
import ConfidenceLevelCard from "@/view/pages/settings/ConfidenceLevelCard.vue";

export default {
  components: {
    ConfidenceLevelCard,
  },
  methods: {
    handleVal(val) {
      this.$emit("save-confidence-settings", val);
    }
  }
  
};
</script>
